export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DownloadDialog.json?hash=5463682a67f254dda8d6f433715f1a22";